export default "__VITE_ASSET__DNEPAsBU__"